import {
  actionTypeFilterToApiType,
  actionTypeValues,
  apiWireActionTypeToFilterValue,
  type ActionTypeFilterValue,
} from './actionTypeFilterTypes';

export type { ActionTypeFilterValue } from './actionTypeFilterTypes';
export { actionTypeValues, actionTypeFilterToApiType } from './actionTypeFilterTypes';

export const actionTypeItems = [
  { label: 'All Actions', value: '' as ActionTypeFilterValue },
  { label: 'Grow', value: 'Growth' as ActionTypeFilterValue },
  { label: 'Shrink', value: 'Shrink' as ActionTypeFilterValue },
  { label: 'Modify', value: 'Modify' as ActionTypeFilterValue },
  {
    label: 'Change Performance Tier',
    value: 'Change Performance Tier' as ActionTypeFilterValue,
  },
  { label: 'Activate Autoscaling', value: 'Activate Autoscaling' as ActionTypeFilterValue },
  { label: 'Deactivate Autoscaling', value: 'Deactivate Autoscaling' as ActionTypeFilterValue },
] as const;

export function parseActionTypeFilter(value: string | null): ActionTypeFilterValue {
  if (!value) {
    return '';
  }
  if ((actionTypeValues as readonly string[]).includes(value)) {
    return value as Exclude<ActionTypeFilterValue, ''>;
  }
  return apiWireActionTypeToFilterValue[value] ?? '';
}

export function appendActionTypeToUrl(url: string, type: ActionTypeFilterValue): string {
  if (!type) return url;
  const questionIndex = url.indexOf('?');
  const path = questionIndex === -1 ? url : url.slice(0, questionIndex);
  const queryString = questionIndex === -1 ? '' : url.slice(questionIndex + 1);
  const params = new URLSearchParams(queryString);
  params.set('type', actionTypeFilterToApiType(type));
  return `${path}?${params.toString()}`;
}

export function optLogActionsCountUrl(
  baseCountQueryString: string,
  type?: Exclude<ActionTypeFilterValue, ''>
): string {
  const params = new URLSearchParams(baseCountQueryString);
  if (type) params.set('type', actionTypeFilterToApiType(type));
  return `/api/v1/opt-log/actions/count?${params.toString()}`;
}

export interface ActionTypeCountLookup {
  type: ActionTypeFilterValue;
  typeCounts: Partial<Record<ActionTypeFilterValue, number>>;
  allActionsCount?: number;
}

export function countForActionType({
  type,
  typeCounts,
  allActionsCount,
}: ActionTypeCountLookup): number | undefined {
  return type ? typeCounts[type] : allActionsCount;
}
